// src/components/ai/RecipeModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import glassshimmer from '../../assets/images/glassshimmer.png';

export default function RecipeModal({ recipe, onClose }) {
  if (!recipe) return null

  const src = recipe.image?.url || glassshimmer
  const alt = recipe.image?.alt || recipe.name

  return (
    <Modal show onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{recipe.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Only render image if recipe.image is defined */}
          <div className="text-center mb-3">
            <img
              src={src}
              alt={alt}
              className="img-fluid rounded"
              style={{ maxWidth: '300px', width: '100%', height: 'auto', backgroundColor: '#fff' }}
            />
          </div>

        <p>{recipe.description}</p>

        <h6>Ingredients</h6>
        <ul>
          {recipe.ingredients.map((ing, i) => (
            <li key={i}>
              {ing.quantity} {ing.unit} {ing.name}
            </li>
          ))}
        </ul>

        <h6>Instructions</h6>
        <ol>
          {recipe.instructions.map((step, i) => (
            <li key={i}>{step}</li>
          ))}
        </ol>
      </Modal.Body>
    </Modal>
  )
}
